__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "nachpay-settlements";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.4", () => (Promise.all([__webpack_require__.e(300), __webpack_require__.e(914), __webpack_require__.e(341)]).then(() => (() => (__webpack_require__(5722))))));
			register("@emotion/styled", "11.11.5", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(519), __webpack_require__.e(860)]).then(() => (() => (__webpack_require__(1479))))));
			register("@mui/icons-material", "5.15.15", () => (Promise.all([__webpack_require__.e(300), __webpack_require__.e(561), __webpack_require__.e(789), __webpack_require__.e(914), __webpack_require__.e(519), __webpack_require__.e(999)]).then(() => (() => (__webpack_require__(4789))))));
			register("@mui/material", "5.15.15", () => (Promise.all([__webpack_require__.e(300), __webpack_require__.e(561), __webpack_require__.e(878), __webpack_require__.e(76), __webpack_require__.e(483), __webpack_require__.e(603), __webpack_require__.e(203), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(519), __webpack_require__.e(999)]).then(() => (() => (__webpack_require__(9203))))));
			register("chart.js", "3.9.1", () => (__webpack_require__.e(50).then(() => (() => (__webpack_require__(3050))))));
			register("react-chartjs-2", "4.3.1", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(495), __webpack_require__.e(734)]).then(() => (() => (__webpack_require__(6734))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(961))))));
			register("react-draggable", "4.4.6", () => (Promise.all([__webpack_require__.e(794), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(175)]).then(() => (() => (__webpack_require__(5794))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(733), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(9733))))));
			register("react-router-dom", "6.22.3", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "18.2.0", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("sheetjs-style", "0.15.8", () => (Promise.all([__webpack_require__.e(664), __webpack_require__.e(599)]).then(() => (() => (__webpack_require__(664))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};